import { EAggregationAnalysisType, IAggregationAnalysisQuarter, IAggregationAnalysisSector } from '~/core/models'

import {
  AGGREGATION_ANALYSIS_DEFAULT_SORT_BY,
  AGGREGATION_ANALYSIS_DEFAULT_SORT_ORDER,
  AGGREGATION_ANALYSIS_DEFAULT_TYPE,
} from './aggregation-analysis.constant'

export const aggregationAnalysisFeatureKey = 'AggregationAnalysis prox'

export interface IAggregationAnalysisQuarterState {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IAggregationAnalysisQuarter[]
  selected?: IAggregationAnalysisQuarter
  aggType: EAggregationAnalysisType
}

export interface IAggregationAnalysisSectorState {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IAggregationAnalysisSector[]
  aggType: EAggregationAnalysisType
  quarter?: IAggregationAnalysisQuarter
  sortBy: string
  order: 'asc' | 'desc' | ''
}

export interface IAggregationAnalysisState {
  quarter: IAggregationAnalysisQuarterState
  sector: IAggregationAnalysisSectorState
  aggType: EAggregationAnalysisType
}

export const createAggregationAnalysisInitState = (): IAggregationAnalysisState => ({
  quarter: {
    initialized: false,
    inRequest: false,
    data: [],
    selected: undefined,
    aggType: AGGREGATION_ANALYSIS_DEFAULT_TYPE,
  },
  sector: {
    initialized: false,
    inRequest: false,
    data: [],
    aggType: AGGREGATION_ANALYSIS_DEFAULT_TYPE,
    quarter: undefined,
    sortBy: AGGREGATION_ANALYSIS_DEFAULT_SORT_BY,
    order: AGGREGATION_ANALYSIS_DEFAULT_SORT_ORDER,
  },
  aggType: AGGREGATION_ANALYSIS_DEFAULT_TYPE,
})

export interface IAppWithAggregationAnalysisState {
  aggregationAnalysis: IAggregationAnalysisState
}
